$ = require 'jquery'
_ = require 'underscore'
Util = require 'app/scripts/lib/util'
{ track, trackUe } = require '@trello/analytics'
TFM = require 'app/scripts/lib/markdown/tfm'
{ TrelloStorage } = require '@trello/storage'
Auth = require 'app/scripts/db/auth'
Layout = require 'app/scripts/views/lib/layout'
{ getKey, isForceSubmitEvent, Key } = require '@trello/keybindings'
PopOver = require 'app/scripts/views/lib/pop-over'
AutoMentionerView = require 'app/scripts/views/internal/autocomplete/auto-mentioner-view'

attachmentAsMarkdown = (attachment) ->
  "[#{ attachment.get('name') }](#{ attachment.get('url') }) "

module.exports._commentDraftKey = -> "draft_#{@model.id}_comment"

module.exports.saveCommentDraft = (didCloseCard = false) ->
  $input = @$('.js-new-comment-input')
  if $input.length == 0
    return
  commentText = $input.val()
  if commentText
    TrelloStorage.set @_commentDraftKey(), commentText
    if didCloseCard
      track('Card Detail', 'Comment', 'Save Comment Draft', @model.trackProperty())
      trackUe('Card Detail', 'save', 'comment draft', '', '', 'when closing a card', '')
  else
    TrelloStorage.unset @_commentDraftKey()
  return

module.exports.keydownCommentEvent = (e) ->
  Auth.me().editing({
    idBoard: @model.getBoard().id
    idCard: @model.id
    action: 'commenting'
  })

  key = getKey(e)

  if key == Key.Tab and $(e.target).hasClass('new-comment-input') and @model.editable() and !(PopOver.view instanceof AutoMentionerView) and $(e.target).val() == ""
    Util.stop(e)
    @submitComment(e)

  if isForceSubmitEvent(e) && !@_isCommentTooLong()
    @submitComment(e)
  else
    @checkInsert(e)

module.exports._isCommentTooLong = ->
  @$('.js-new-comment-input').val()?.length > @maximumCommentLength

module.exports.renderCommentSubmitAbility = (e) ->
  isTooLong = @_isCommentTooLong()
  noInput = @$('.js-new-comment-input').val()?.length == 0
  isDisabled = noInput || isTooLong
  @$('.js-add-comment').prop('disabled', isDisabled)
  @$('.js-comment-subscribe').toggleClass('is-visible', !isDisabled && !@model.isSubscribed())
  @$('.comment-too-long-warning').toggleClass('is-shown', isTooLong)
  @$('.comment-too-long-warning').find('.js-attach-comment').toggle(Blob?)
  @renderCommentControls()
  @

module.exports.renderCommentControls = (e) ->
  $comment = @$('.js-new-comment')
  hasInput = @$('.js-new-comment-input').val()?.length > 0
  $comment.toggleClass('is-show-controls', hasInput)
  @

module.exports.renderCommentAndSubscribeBox = (e) ->
  @$('.js-comment-subscribe').toggleClass('is-subscribed')
  @

module.exports._cancelEditing = ->
  Auth.me().editing({ idBoard: @model.getBoard().id })

module.exports.commentInputEvent = (e) ->
  @renderCommentSubmitAbility()
  @renderCommentControls()
  @$('.js-new-comment-input').trigger('autosize.resize')
  @

module.exports.clearComment = ->
  $input = $(@commentInput)

  $input
  .val('')
  .css('height', '') # In case they resized the textarea

  @renderCommentSubmitAbility()

module.exports.submitComment = (e) ->
  track("Card Detail", "Comment", "Submit Comment", @model.trackProperty())
  Util.stop(e)

  $input = $(@commentInput)
  text = $input.val()

  @clearComment()

  @_cancelEditing()
  @model.addComment(text)

  # Tracking for direct mentions of invitees
  mentionedUsernames = text?.match(/@\w+/g)?.map((s) -> s.substring(1).toLowerCase()) ? []
  mentionedUsernames = _.uniq(mentionedUsernames)
  boardMembers = @model.getBoard().memberList.models
  myId = Auth.me().id
  mentionedUsernames.forEach((mentionedUsername) ->
    if mentionedUsername != "card" and mentionedUsername != "board" and mentionedUsername != "commenters"
      # Find the board member with this username, see if we invited them
      boardMembers.forEach((boardMember) ->
        if boardMember.get('username') == mentionedUsername and boardMember.get('idMemberReferrer') == myId
          trackUe('card detail', 'mentions', 'invitee', '', '', '', { member: myId, mentionedMember: boardMember.id })
      )
  )

  if Auth.me().isSubscribeOnCommentEnabled() && !@model.isSubscribed()
    @model.subscribe(true)

  Layout.cancelEdits()
  @collapseComment()
  @renderCommentSubmitAbility()

  PopOver.hide()

  false

module.exports.subscribeOnComment = (e) ->
  Util.stop(e)

  me = Auth.me()

  if !me.isSubscribeOnCommentEnabled()
    track("Card Detail", "Comment and Subscribe", "Enable", @model.trackProperty())
  else
    track("Card Detail", "Comment and Subscribe", "Disable", @model.trackProperty())

  @renderCommentAndSubscribeBox()

  me.toggleSubscribeOnComment()

  false

module.exports.truncateComment = (e) ->
  $comment = @$('.js-new-comment-input')
  $comment.val($comment.val().substr(0, @maximumCommentLength))
  @$('.js-new-comment-input').autosize(append: false)
  @renderCommentSubmitAbility()

module.exports.inputComment = (e) ->
  $comment = @$('.js-new-comment')
  Layout.cancelEdits(@commentInput)
  $comment.addClass('is-focused')
  @$('.js-new-comment-input').autosize(append: false)
  return

module.exports.clickAwayFromComment = (e) ->
  # If there's a popover open, and someone "clicks away," they're
  # *probably* trying to dismiss the popover, not the comment box.
  if PopOver.isVisible
    return

  # Don't collapse the comment box unless the textarea has blurred.
  # This fixes a bug where you can `mousedown` (to focus the textarea)
  # hold your mouse down, move it out of the comment box, then
  # release (`click`), causing the comment box to collapse.
  if (document.activeElement == @commentInput)
    return

  # Don't collapse if we're clicking anywhere inside the comment area,
  # like on buttons.
  el = e.target
  $comment = @$('.js-new-comment')

  # We might not have a comment input if we're in template or don't
  # have permission to comment
  if $comment[0]?.contains(el)
    return

  @collapseComment()

module.exports.collapseComment = ->
  @$('.js-new-comment').removeClass('is-focused')
  @$('.js-new-comment-input').trigger('autosize:destroy')

module.exports.replyToAction = (e, action) ->
  memberCreator = @modelCache.get('Member', action.get('idMemberCreator'))
  username = memberCreator?.get('username')

  $comment = @$(@commentInput)

  replyText =
    if action.isCommentLike() && username?
      Layout.cancelEdits(@commentInput)
      # Only add the @mention if they haven't already added one; maybe they
      # clicked 'reply' twice or something
      if ///@#{ username }(\W|$)///.test($comment.val())
        $comment.focus()
        null
      else
        "@#{username} "
    else if action.isAddAttachment() && (attachment = @model.attachmentList.get(action.get('data').attachment?.id))?
      attachmentMarkdown = attachmentAsMarkdown(attachment)
      if Auth.isMe(memberCreator)
        attachmentMarkdown
      else
        ["@#{ username }", attachmentMarkdown].join(' ')

  if replyText
    $comment.addClass('is-focused')
    Util.insertSelection($comment, replyText)
    $comment.trigger('autosize.resize')
    @$('.js-new-comment-input').autosize(append: false)

  return

module.exports.replyToAllAction = (e, action) ->
  memberCreator = @modelCache.get('Member', action.get('idMemberCreator'))
  username = memberCreator?.get('username')

  # Cache the current values for comment
  $comment = @$(@commentInput)
  commentText = $comment.val()

  mentionsFromText = (markdown) ->
    _.uniq(TFM.comments.getMatches(markdown, { 'atMention': true }).atMention)

  mentions = _.chain(["@#{ username }"])
    .concat(mentionsFromText(action.get('data').text))
    .uniq((a) -> a.toLowerCase())
    .filter (mention) ->
      [username, isMe] = TFM.lookupMember mention.replace '@', ''
      !isMe
    .without(
      mentionsFromText(commentText)...
    )
    .value()

  # Tracking for @card then remove them
  if(_.contains(mentions, '@card') || _.contains(mentions, '@board'))
    track("Card", "Reply to all with a @card or @board mention", undefined, @model.trackProperty())

  mentions = _.without(mentions, '@card', '@board')

  # Track how many users have been added
  track("Card", "Reply to all Comment Mention Count", undefined, @model.trackProperty(), mentions.length)

  if mentions.length
    replyText = mentions.join(" ") + " "
    $comment.addClass('is-focused')
    Util.insertSelection($comment, replyText)
    $comment.trigger('autosize.resize')
  else
    $comment.focus()

  return

module.exports.replyToAttachment = (attachment) ->
  Layout.cancelEdits(@commentInput)
  $comment = @$(@commentInput)
  $comment.addClass('is-focused')
  Util.insertSelection($comment, attachmentAsMarkdown(attachment))
  $comment.trigger('autosize.resize')

module.exports.replyToComment = (replyToComment) ->
  if @model.getBoard().canComment(Auth.me()) && replyToComment
    $newCommentInput = @$('.js-new-comment-input')
    $newCommentInput.val("@#{replyToComment} ")
    $newCommentInput.focus()
    Util.setCaretAtEnd($newCommentInput[0])

  @renderCommentSubmitAbility()

  return
